import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeft, ChevronRight } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
export const TranscriptSearchControls = /*#__PURE__*/ memo((param)=>{
    let { onPrevClick, onNextClick, totalResults, currentWordIndex } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "TRANSCRIPT_SEARCH_CONTROLS",
        className: "flex items-center",
        children: [
            totalResults > 0 && /*#__PURE__*/ _jsxs("span", {
                "data-testid": "TRANSCRIPT_SEARCH_RESULTS_COUNT",
                className: "mr-1 text-10 text-grey-11",
                children: [
                    currentWordIndex === -1 ? "-" : currentWordIndex + 1,
                    "/",
                    totalResults
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                disabled: !onPrevClick,
                "data-testid": "TRANSCRIPT_SEARCH_PREVIOUS",
                label: "Pevious word",
                icon: ChevronLeft,
                onClick: onPrevClick,
                size: "small",
                color: "grey",
                className: "rounded-l rounded-r-none"
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                disabled: !onNextClick,
                "data-testid": "TRANSCRIPT_SEARCH_NEXT",
                label: "Next word",
                icon: ChevronRight,
                size: "small",
                onClick: onNextClick,
                color: "grey",
                className: "rounded-l-none rounded-r"
            })
        ]
    });
});
TranscriptSearchControls.displayName = "TrnascriptSearchControls";
